<div class="page-container" [class.show-ai-chat]="showAiChat">
  <button *ngIf="deviceSize !== 'mobile'" class="ai-chat-button" (click)="showAiChat = !showAiChat">
    <i-tabler name="message"></i-tabler>
    KI-Chat
  </button>

  <form [formGroup]="form!">
    <app-quill-textarea formControlName="front" [control]="getControl('front')" [label]="'Vorderseite'" type="text" [placeholder]="'Inhalt der Vorderseite'" [size]="'big'"></app-quill-textarea>
    <app-quill-textarea formControlName="back" [control]="getControl('back')" [label]="'Rückseite'" type="text" [placeholder]="'Inhalt der Rückseite'" [showActionButton]="true" [actionButtonText]="'Mit KI generieren'" (actionButtonClicked)="generateBackContent()" [size]="'big'"></app-quill-textarea>
  </form>
  
  <ng-container *ngIf="showAiChat">
    <div class="vertical-divider"></div>
    <app-ai-chat></app-ai-chat>
  </ng-container>
</div>

<div class="footer">
  <app-button [text]="'Änderungen speichern'" type="submit" [loading]="isLoading" (clickEvent)="updateFlashcard()"></app-button>
</div>
